import axios from 'axios';
import { serializeData } from '../forms';
import { hostname } from '../host';

const encodeCredentials = (credentials) => {
    let userPass = credentials.email + ':' + credentials.password;
    /*if (credentials.firstName && credentials.lastName) {
        userPass += ':' + credentials.firstName + ':' + credentials.lastName;
    }*/

    let octetString = userPass;
    //let basicAuthValue = 'Basic ' + new Buffer(octetString).toString('base64');
    let basicAuthValue = 'Basic ' + btoa(octetString);
    return basicAuthValue;
};

export async function register(credentials) {
    let basicAuthValue = encodeCredentials(credentials);
    let formBody = serializeData(credentials, 'firstName', 'lastName');

    const res = await axios.post(hostname() + 'rest/register',
        formBody,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': basicAuthValue
            }
        }
    );

    console.log(res);
}

export function getAccessToken() {
    // Stored in localStorage (not sessionStorage) so authentication survives
    // mobile app-switching: mobile browsers clear sessionStorage when they
    // evict a backgrounded tab, which used to silently sign the user out.
    return localStorage.getItem('token');
}

// The logged-in username, stored alongside the token at login and cleared on
// sign-out. Lets a restored session (page reload) recover the identity without
// a fresh SESSION_ACTION.
export function getLogin() {
    return localStorage.getItem('login');
}

export async function signOut() {
    // TODO something server side
    var signOutAttempt = {

    }

    localStorage.removeItem('token');
    localStorage.removeItem('login');

    return signOutAttempt;
}

export async function clearCredentials() {
    localStorage.removeItem('token');
    localStorage.removeItem('login');
}

export async function login(credentials) {
    var loginAttempt = null;
    let basicAuthValue = encodeCredentials(credentials);

    try {
        const res = await axios.post(hostname() + 'rest/auth',
            //{ example: 'data' },
            null, // empty body
            {
                //headers: { 'Content-Type': 'application/json' }
                headers: { 'Authorization': basicAuthValue }
            }
        );

        let start = res.data.token.indexOf('.') + 1;
        let end = res.data.token.indexOf('.', start);
        let payload = res.data.token.substring(start, end);
        //let accountDataString = new Buffer(payload, 'base64').toString('ascii');
        let accountDataString = atob(payload);

        loginAttempt = {
            account: JSON.parse(accountDataString)
        }

        localStorage.setItem('token', res.data.token);
        localStorage.setItem('login', loginAttempt.account.login);
    }
    catch (err) {
        // Keep the raw axios error for debugging, but never show its
        // "Request failed with status code 401" text to the user.
        console.error(err);
        loginAttempt = {
            error: new Error(friendlyLoginError(err))
        }
    }

    return loginAttempt;
}

// Translate an axios login failure into human, actionable copy. We deliberately
// don't say whether the email or the password was wrong (avoids account
// enumeration) and never surface raw HTTP status codes.
function friendlyLoginError(err) {
    const status = err.response && err.response.status;

    if (status === 401 || status === 403) {
        return "Your email or password wasn't recognized.";
    }
    if (!err.response) {
        // No response at all — network down, CORS, server unreachable.
        return "We couldn't reach the server. Check your connection and try again.";
    }
    if (status >= 500) {
        return "Something went wrong on our end. Please try again in a moment.";
    }
    return "Please try again, or reset your password if this keeps happening.";
}
